export const VERSION = "v1.0.0";
